import { Page, Text, View, Document, StyleSheet, Font, Image, } from "@react-pdf/renderer";
import React from "react";
import PropTypes from 'prop-types';
import LatoRegular from "../../Assets/Fonts/Lato-Font/Lato-Regular.ttf";
import LatoBold from "../../Assets/Fonts/Lato-Font/Lato-Bold.ttf";
import Header from "../../Components/GeneratePdf/Header";
import Footer from "../../Components/GeneratePdf/Footer";

Font.register({
  family: "Lato",
  fonts: [ { src: LatoRegular, fontWeight: 400 }, { src: LatoBold, fontWeight: 700 }, ],
});

const styles = StyleSheet.create({
  pagewapper: { position: "relative", height: "100%", },
  content: { display: "flex", width: "570px", alignItems: "left", },
  contenttitle: { fontFamily: "Lato", fontWeight: 700, fontSize: "18px", lineHeight: "30px", color: "#426B88", },
  wapper: { width: "567px", fontFamily: "Lato", fontWeight: 400, fontSize: "12px", lineHeight: "18px", color: "#245775", },
  mainContent: { flexGrow: 1, marginTop: "28px", },
  footer: { marginTop: "auto", },
  table: { width: "100%", },
  tableRow: { flexDirection: "row", paddingVertical: 2, alignItems: "center", },
  tableHeader: { paddingVertical: 1, fontWeight: 400, border: "0px", backgroundColor: "#245775", fontWeight: "bold", color: "white", borderTopLeftRadius: 4, borderTopRightRadius: 4, },
  headerCell: { color: "white", fontWeight: 400, paddingVertical: "5px" },
  cellQuestion: { width: "70%", fontSize: 10, color: "#394554", fontWeight: 400, },
  cellScore: { width: "7%", textAlign: "center", fontSize: 10 },
  cell: { padding: "10px", textAlign: "left", },
  rowEven: { backgroundColor: "#F1F3F3", },
  rowOdd: { backgroundColor: "#FFF", },
  redRectangle: { width: 17, height: 17, backgroundColor: "#B6111F", borderRadius: "1.34px", },
});

const truncateText = (text, limit) => {
  if (text.length <= limit) return text;
  return text.substring(0, text.lastIndexOf(" ", limit)) + "...";
};

const getLastFilledIndex = (scores) => {
  for (let i = scores.length - 1; i >= 0; i--) {
    if (scores[i] === 1) return i;
  }
  return -1;
};

const renderRectangle = (score, index, scores) => {
  const lastFilledIndex = getLastFilledIndex(scores);
  return index <= lastFilledIndex ? <View style={styles.redRectangle} /> : null;
};

const QuadrantFlowHeart360 = ({ apiData = {} }) => {
  console.log("apiData in QuadrantFlowHeart360", apiData)
  const respondentName = apiData?.fullName?.split(' ')[0] || 'Respondent';
  console.log("respondentName", respondentName)
  // Process questions to replace [First Name] with the actual respondent's name
  const processedQuestions = data.map(item => ({
    ...item,
    question: item.question.replace(/\[First Name\]/g, respondentName)
  }));
  
  return (
  <View style={styles.pagewapper}>
    <Header />
    <View style={styles.content}>
      <Text style={styles.contenttitle}>HEART 360 IN FOCUS</Text>
      <View style={styles.wapper}>
        <Text>
        This chart isolates the items related to the Heart based on the OBSERVER ratings (SELF excluded). Focused results reflect the average of observer scores only. The response scale runs from 1 (Least) to 4 (Most). Any unselected statement will appear blank in the In Focus section.
        </Text>
      </View>
    </View>
    <View style={styles.mainContent}>
      <View style={[styles.tableRow, styles.tableHeader]}>
        <Text style={[styles.cell, styles.cellQuestion, styles.headerCell]}>
          Heart
        </Text>
        {[1, 2, 3, 4].map((num) => (
          <Text
            key={num}
            style={[styles.cell, styles.cellScore, styles.headerCell]}
          >
            {num}
          </Text>
        ))}
      </View>

      {processedQuestions.map((item, index) => (
        <View key={index} style={[ styles.tableRow, index % 2 === 0 ? styles.rowEven : styles.rowOdd, ]} >
          <Text style={[styles.cell, styles.cellQuestion]}>
          {item.question.replace(/\[First Name\]/g, respondentName)}
          </Text>
          {item.scores.map((score, idx) => (
            <View key={idx} style={[styles.cell, styles.cellScore]}>
              {renderRectangle(score, idx, item.scores)}
            </View>
          ))}
        </View>
      ))}
    </View>
    <Footer />
  </View>
  );
};

QuadrantFlowHeart360.propTypes = {
  apiData: PropTypes.shape({
    fullName: PropTypes.string,
    // Add other expected properties from apiData if needed
  })
};

QuadrantFlowHeart360.defaultProps = {
  apiData: {}
};

export default QuadrantFlowHeart360;

const data = [
  {
    id: 1,
    quadrant: "HEART",
    question: "When presented with a problem, [First Name] is most concerned with how the team is handling it.",
    scores: [1, 1, 1, 1],
  },
  {
    id: 2,
    quadrant: "HEART",
    question: "[First Name] ensures their decisions are measured by whether everyone is on board.",
    scores: [1, 1, 1, 1],
  },
  {
    id: 3,
    quadrant: "HEART",
    question: "[First Name] feels most fulfilled when surrounded by their people.",
    scores: [1, 1, 1, 1],
  },
  {
    id: 4,
    quadrant: "HEART",
    question: "[First Name] is motivated when they feel a sense of belonging.",
    scores: [1, 1, 1, 1],
  },
  {
    id: 5,
    quadrant: "HEART",
    question: "[First Name] relies heavily on passion when working on a project.",
    scores: [1, 1, 1, 1],
  },
  {
    id: 6,
    quadrant: "HEART",
    question: "[First Name] believes a collaborative team is the best way to achieve results.",
    scores: [1, 1, 1, 1],
  },
  {
    id: 7,
    quadrant: "HEART",
    question: "[First Name] wants to feel connected to others while doing something.",
    scores: [1, 1, 1, 1],
  },
  {
    id: 8,
    quadrant: "HEART",
    question: "When working on a project, [First Name] can become too emotionally invested.",
    scores: [1, 1, 1, 1],
  },
  {
    id: 9,
    quadrant: "HEART",
    question: "[First Name]'s strong feelings sometimes overwhelm good judgment.",
    scores: [1, 1, 1, 1],
  },
  {
    id: 10,
    quadrant: "HEART",
    question: "When sharing a proposal, [First Name] wants to know 'who' is on board.",
    scores: [1, 1, 1, 1],
  },
];
